import Vue from 'vue'
export default {
  getSurveyOptions(type) {
    return Vue.http.get(`surveys/data/${type}/options`).then(res => res.body)
  },

  list(params) {
    return Vue.http.get('surveys/list', {params}).then(res => res.body)
  }
}
